/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../shared/context/PlayerTranslationContext";
import PauseIcon from "../../../../../shared/icons/player/Pause.svg";
import PlayIcon from "../../../../../shared/icons/player/Play.svg";
import { usePlayerSettings } from "../../../../BasePlayer";
import { usePlayerPlayingState } from "../../../../Controller";

export const PlayPauseButton = () => {
  const { isPlaying, togglePlay } = usePlayerPlayingState();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();
  const label = t(isPlaying ? "PLAYER_TOOLTIP_PAUSE" : "PLAYER_TOOLTIP_PLAY");

  return (
    <Button
      variant="primary"
      onClick={togglePlay}
      tooltip={label}
      tooltipAlign="left"
      tooltipOffset={tooltipOffset}
      aria-label={label}
      iconOnly
    >
      {isPlaying ? (
        <PauseIcon aria-hidden="true" focusable="false" />
      ) : (
        <PlayIcon aria-hidden="true" focusable="false" />
      )}
    </Button>
  );
};
